<template>
    <section class="pdp-page-content pdp-blackrabbit-content"
        :class="['layout-'+gridLayout, {'pdp-safari' : isSafari, 'pdp-firefox' : isFirefox}]"
        id="pdpPageContent"
    >
        <LastOrderNotice v-if="pageLoaded && lastOrderUrl" :is-desktop="true" :is-black-rabbit="true" :url="lastOrderUrl" :group-id="groupId"/>
        <Breadcrumbs :page-loaded="pageLoaded" :mub="breadcrumbsMub" :links="breadcrumbs && breadcrumbs.links"/>
        <div v-show="!isUnavailableProduct" class="page-core">
            <div class="pdp-blocks-section">
                <GalleryBlocks v-if="galleryData"
                    :gallery-data="galleryData"
                    :class="{'gallery-disabled' : isNVproduct}"
                />
                <!-- PDP BLACK RABBIT BLOCKS -->
                <ContentDetails :page-loaded="pageLoaded" />
            </div>
            <div class="pdp-control-section"
                :class="{'widget-full-page' : widgetFullPage, 'scroll-minimal-mode' : (enableSideDetails || enableReverseSideDetails) && scrollMinimalMode}"
                ref="controlSection"
                v-observe-visibility="{
                        callback: (visible) => { this.sideDetailsFullyVisible = visible},
                        intersection: {
                            threshold: 1,
                        }
                    }"
            >
                <div v-if="!infoPdpMode && (pageLoaded && addToCartData)" class="pdp-cart-widget" :class="{'unavailable-product' : isNVproduct || isUnavailableProduct, 'scroll-minimal-mode' : scrollMinimalMode}">
                    <InfoSection :detailed-info="infoSectionData" :k-strings="kStrings" :scroll-minimal-mode="scrollMinimalMode" :show-copy-link="!basicInfo.isPartner"/>
                    <AddToCartDesktop v-if="addToCartData" :context-notification="contextNotification" ref="addToCart"/>
                </div>
                <div v-else-if="infoPdpMode && (pageLoaded && infoSectionData)" class="pdp-cart-widget">
                    <p class="min-info"> {{ infoSectionData.name }} </p>
                </div>
                <div v-if="!pageLoaded" class="pdp-cart-widget skeleton-box"/>
                <div class="detached-container" :class="{'skeleton-box' : !pageLoaded, 'nv-product' : isNVproduct}" id="detachedContainer">
                    <button v-if="(infoPdpMode || isNVproduct) && pageLoaded" class="big-link-button" @click="goBack(isNVproduct)">
                        <i v-if="infoPdpMode" class="prz-chevron-left"/> {{ infoPdpMode ? kStrings.kBACK_TO_PACK : kStrings.kSEE_MORE_PRODUCTS }}
                    </button>
                </div>
                <div v-if="enableSideDetails || enableReverseSideDetails" class="pdp-side-details" :class="{'reverse' : enableReverseSideDetails}" id="sideDetails" ref="sideDetails">
                    <ComboList :key="'comboList-' + groupId"
                        :class="{'limit-view' : enableReverseSideDetails}"
                        @open-fp="widgetFullPage = true"
                        @close-fp="widgetFullPage = false"
                        @sideScrollListener="toggleSideListener"
                        @loaded="initSideScrollEvents"
                    />
                    <CampaignList :key="'cpgList-' + groupId" @open-fp="widgetFullPage = true" @close-fp="widgetFullPage = false" id="sideCpg"/>
                </div>
            </div>
        </div>
        <transition name="fade">
            <UnavailableInfo v-if="isUnavailableProduct"/>
        </transition>
        <transition name="fade">
            <VideoModal v-if="showVideoModal"/>
        </transition>
        <BlackRabbitModal
            v-if="showMoreInfoModal"
            :showFooter="true"
            class="modal override-more-info"
            @close="onClose"
        >
        <template v-slot:content>
            <section v-html="reasonDetailContent"></section>
        </template>
        <template v-slot:footer>
            <div class="modal-footer-content">
                <button class="close-button" @click="onClose()">{{kStrings.kCLOSE}}</button>
            </div>
        </template>
        </BlackRabbitModal>
    </section>
</template>

<script>

import {storePdp} from '@/store/product-page';
import request from '@/Utilities/httpRequest';
import pdpEvents from '@/Utilities/events-pdp/events';
import utilities from "@/Utilities/common";
//import UnavailableInfo from "@/components/ProductPage/Desktop-BlackRabbit/BlocksSection/UnavailableInfo.vue";
import browser from '@/Utilities/browser';

import AddToCartDesktop from '@/components/ProductPage/Desktop-BlackRabbit/AddToCartDesktop/AddToCartDesktop.vue';
import GalleryBlocks from "@/components/ProductPage/Desktop-BlackRabbit/BlocksSection/GalleryBlocks.vue";
import BlackRabbitModal from '@/components/BlackRabbit/ModalDesktop.vue';

import Vue from 'vue';
import {ObserveVisibility} from 'vue-observe-visibility';
Vue.directive('observe-visibility', ObserveVisibility);

export default {
    store: storePdp,
    name: 'ProductPage',
    components: {
        AddToCartDesktop,
        GalleryBlocks,
        UnavailableInfo: () => import('@/components/ProductPage/Desktop-BlackRabbit/BlocksSection/UnavailableInfo.vue'),
        VideoModal: () => import('@/components/ProductPage/Desktop-BlackRabbit/VideoModal.vue'),
        ContentDetails: () => import('@/components/ProductPage/Desktop-BlackRabbit/BlocksSection/ContentDetails.vue'),
        Breadcrumbs: () => import('@/components/ProductPage/Desktop-BlackRabbit/Breadcrumbs.vue'),
        InfoSection: () => import('@/components/ProductPage/Desktop-BlackRabbit/AddToCartDesktop/InfoSection.vue'),
        LastOrderNotice: () => import('@/components/ProductPage/Desktop-BlackRabbit/LastOrderNotice.vue'),
        CampaignList: () => import('@/components/ProductPage/Desktop-BlackRabbit/SideElements/CampaignList.vue'),
        ComboList: () => import('@/components/ProductPage/Desktop-BlackRabbit/SideElements/ComboList.vue'),
        BlackRabbitModal 
    },
    props: {
        galleryPreload: {
            type: Array,
            default: () => undefined,
        },
        url: {
            type: String,
            default: null,
        },
        infoPdpMode: { // ex: for pack content items, maybe more
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            defaultUrl: null,

            pageLoaded: false,
            partnerData: null,
            widgetFullPage: false,
            sideDetailsFullyVisible: false, // -> true does not compact widget
            sideScrollListener: false,
            contextNotification:null,
        };
    },
    created() {
        this.$store.dispatch('pdpDesktop/setLoading', true);
        this.$store.dispatch('pdpDesktop/updateGridLayout');
        if(this.galleryPreload){
            this.$store.dispatch('gallery/setData', this.galleryPreload);
        }
        this.defaultUrl = !this.url ? window.location.href : this.url;
        if (typeof pdp_data === 'undefined' || pdp_data === null) {
            this.load();
        } else {
            this.initData(pdp_data);
        }
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
    },
    watch: {
        groupId(newVal, oldVal){
            if(oldVal){
                pdpEvents.addGroupIdChange(newVal);
            }
        },
    },
    computed: {
        lastOrderUrl() {
            return this.$store.getters['pdpDesktop/lastOrderUrl'];
        },
        groupId() {
            return this.$store.getters.GroupId;
        },
        sku() {
            return this.$store.getters.SKU ?? this.$store.getters.masterSku;
        },
        breadcrumbsMub() {
            return this.breadcrumbs && this.breadcrumbs.mub ? this.breadcrumbs.mub : null;
        },
        breadcrumbs() {
            if(this.isUnavailableProduct) {
                return null;
            }
            return this.$store.getters.breadcrumbs;
        },
        isLoading() {
            return this.$store.getters['pdpDesktop/isLoading'];
        },
        currentGroupId() {
            return this.$store.getters.GroupId;
        },
        kStrings() {
            return this.$store.getters.kStrings;
        },
        addToCartData() {
            return this.$store.getters['pdpDesktop/addToCartData'];
        },
        infoSectionData() {
            return this.$store.getters['pdpDesktop/infoSectionData'];
        },
        galleryData() {
            let gallery = this.$store.getters['gallery/struct'] ?? undefined;

            //fi is loading
            if(!gallery && !this.pageLoaded){
                gallery = {
                    sku: this.sku,
                    groupId: this.groupId,
                    images:[],
                    videos:[]
                };

                for(let i =0; i<5; i++){
                    gallery.images.push({
                        position: i +1,
                        loading: true,
                        src: ''
                    })
                }
            }

            return gallery;
        },
        isUnavailableProduct() {
            return this.productStatus == 'DE';
        },
        isNVproduct() {
            if(this.isUnavailableProduct) {
                return false;
            }

            return this.productStatus == 'NV' || (this.basicInfo && (this.basicInfo.isDisabled || this.basicInfo.isSampleProduct));
        },
        homeUrl() {
            return this.$store.getters['pdpDesktop/homeUrl'];
        },
        activeProduct() { // shows widgets and
            // NL products are special cases...
            // no AC -> TI with no override set to active
            //if(this.productStatus == 'NL' || this.productStatus == 'NV') {
            if (this.productStatus == 'NL' || this.productStatus == 'TI') {
                return true;
            }
            return this.productStatus == 'AC' || (this.basicInfo && this.basicInfo.isActive);
        },
        productStatus() {
            return this.$store.getters['pdpDesktop/addToCartDesktop/productStatus'];
        },
        basicInfo() {
            return this.$store.getters['pdpDesktop/basicInfoData'];
        },
        infoSectionData() {
            return this.$store.getters['pdpDesktop/infoSectionData'];
        },
        addToCartData() {
            return this.$store.getters['pdpDesktop/addToCartData'];
        },
        gridLayout() {
            return this.$store.getters['pdpDesktop/gridLayout'];
        },
        showVideoModal() {
            return this.$store.getters['pdpDesktop/videoModal'].show;
        },
        isSafari() {
            return browser.isSafari();
        },
        isFirefox() {
            return browser.getBrowser() === 'firefox';
        },
        enableSideDetails() {
            if(this.infoPdpMode || !this.pageLoaded) {
                return false
            }
            return this.$store.getters['pdpDesktop/enableSideDetails'];
        },
        enableReverseSideDetails() {
            if(this.infoPdpMode || !this.pageLoaded) {
                return false
            }
            return this.$store.getters['pdpDesktop/enableReverseSideDetails'];
        },
        scrollMinimalMode() {
            return this.$store.getters['pdpDesktop/scrollMinimalMode'];
        },
        pointsUrl() {
            return this.$store.getters['pdpDesktop/pointsUrl'];
        },
        selectedProduct() {
            return storePdp.getters['pdpDesktop/addToCartDesktop/selectedProduct'];
        },
        reasonDetailContent(){
            return this.selectedProduct.overrideStatus && this.selectedProduct.overrideStatus.hasOwnProperty('content') ? this.selectedProduct.overrideStatus.content : null;
        },
        showMoreInfoModal() {
            return storePdp.getters.showMoreInfoModal;
        }
    },
    methods: {
        async initData(data) {
            if(!data || (data.error === 'ECONNABORTED')){
                // no data or aborted request (browser navigated away from page)
                return;
            }

            await this.$store.dispatch('pdpDesktop/initWsData', data);
            this.pageLoaded = true;
            window.addEventListener('resize', this.onResize);
            if(data){
                this.partnerData         = data.hasOwnProperty('partner') ? data.partner : null;
                this.contextNotification = data.hasOwnProperty('contextNotification') ? data.contextNotification : null;
            }

            // Fix Noibu #5023: undefined is not an object (evaluating 'data.addToCart.products')
            if(data && data.hasOwnProperty('addToCart')){
                if(data.addToCart.hasOwnProperty('products')){
                    pdpEvents.addInit(data.groupId, this.productStatus, data.addToCart.products);
                }
                else if(data.addToCart.hasOwnProperty('pack')){
                    pdpEvents.addInit(data.groupId, this.productStatus, null, {sku: data.addToCart.defaultSku, hasStock: data.addToCart.hasStock});
                }    
            }
        },
        async load() {
            let defaultUrl = window.product_option?.productInfo?.url ?? null;
            let origin     = window.location?.origin??'';
            let igrOptions = defaultUrl && this.defaultUrl.replace(origin,'') == defaultUrl.replace(origin,'') ? true : false;
            const {data}   = await request.post(this.defaultUrl,{ignoreOptions: igrOptions});
            if(igrOptions){
                data.addToCart = product_option;
            }
            this.initData(data);
        },

        onResize() {
            this.$store.dispatch('pdpDesktop/updateGridLayout');
        },
        goBack(goHome = false) {
            if(goHome &&  this.addToCartData?.productInfo?.nvPointsOnly){
                utilities.goToUrl(this.pointsUrl);
                return;
            }
            if(goHome) {
                utilities.goToUrl(this.homeUrl);
            } else {
                history.back();
            }
        },
        toggleSideListener(status) {
            this.sideScrollListener = status;
            if(!status) {
                this.$store.commit('pdpDesktop/setScrollMinimalMode', false);
            }
        },
        initSideScrollEvents() {
            let posY = 0;
            const pdpComboBlocks = document.getElementById('pdpComboBlocks');
            window.addEventListener("scroll", () => {
                let thresholdPos = pdpComboBlocks ? pdpComboBlocks.offsetTop - pdpComboBlocks.getBoundingClientRect().height : 76;
                posY = window.scrollY;
                if(this.sideScrollListener && !this.sideDetailsFullyVisible) {
                    this.$store.commit('pdpDesktop/setScrollMinimalMode', posY > thresholdPos);
                } else if(posY <= thresholdPos) {
                    this.$store.commit('pdpDesktop/setScrollMinimalMode', false);
                }
            });
        },
        onClose(){
            storePdp.dispatch('showMoreInfoModal', false);
            utilities.enableBodyScroll();
        },
    },
};
</script>


<style lang="scss">
@import "./styles/index";
</style>
